function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as r } from "./index.es33.js";
import { useState as h, useRef as x, useEffect as A } from "react";
import { clsx as o } from "./index.es105.js";
import { Typography as s } from "./index.es35.js";
import "./index.es36.js";
import { VariableWrapper as D } from "./index.es452.js";
import { BORDER_BRACKETS_REGEXP as N } from "./index.es453.js";
import i from "./index.es111.js";
import a from "./index.es454.js";

var _ = function _(b) {
  var n = b.value,
      g = b.placeholder,
      c = b.label,
      v = b.hint,
      p = b.isDisabled,
      u = b.isError,
      y = b.options,
      j = b.noOptionsText,
      E = b.onAddVariable,
      R = b.onChange,
      V = b.validate,
      B = b.isAddVariablePending,
      _b$popupAlignment = b.popupAlignment,
      C = _b$popupAlignment === void 0 ? "left" : _b$popupAlignment,
      _h = h(!1),
      _h2 = _slicedToArray(_h, 2),
      S = _h2[0],
      m = _h2[1],
      _h3 = h(n ? "{{".concat(n, "}}") : ""),
      _h4 = _slicedToArray(_h3, 2),
      t = _h4[0],
      d = _h4[1],
      l = x(null),
      f = x(null);

  return A(function () {
    var e = t.replace(N, "");
    e !== n && (R === null || R === void 0 ? void 0 : R(e));
  }, [t]), r.jsxs("div", {
    className: a.container,
    children: [c && r.jsx(s.Body2, {
      as: "div",
      className: o(i.labelContainer, i.label),
      children: c
    }), r.jsx("div", {
      className: a.inputContainer,
      children: r.jsx(D, {
        textareaRef: f,
        mirrorRef: l,
        value: t,
        options: y,
        isFocused: S,
        isDisabled: p,
        isError: u,
        noOptionsText: j,
        onAddVariable: E,
        isAddVariablePending: !!B,
        validate: V,
        onChange: d,
        popupAlignment: C,
        children: r.jsx(s.Body2, {
          as: "input",
          ref: f,
          className: o(i.input, a.input),
          disabled: p,
          value: t,
          placeholder: g,
          onChange: function onChange(e) {
            return d === null || d === void 0 ? void 0 : d(e.target.value);
          },
          onFocus: function onFocus() {
            return m(!0);
          },
          onBlur: function onBlur() {
            return m(!1);
          },
          onKeyDown: function onKeyDown(e) {
            e.key === "Enter" && e.preventDefault(), e.key === "Backspace" && !n && e.preventDefault();
          },
          onScroll: function onScroll(e) {
            l.current && (l.current.scrollLeft = e.currentTarget.scrollLeft);
          }
        })
      })
    }), r.jsx(s.Small, {
      className: o(a.hint, _defineProperty({}, a.errorHint, u)),
      children: v
    })]
  });
};

export { _ as VariableSelect };